import React from 'react';
import { ModalTitle } from './ModalTitle';
import { MarketingPreferences } from './ModalMarketingPreferences';

import { getTranslation } from 'common/react/utils/translations';

export const CommunicationsModalWrapper = () => {
    return (
        <>
            <ModalTitle
                title={getTranslation('settingsModal.aflidSettings')}
                closeBtn={false}
            />
            <MarketingPreferences
                title={getTranslation(
                    'settingsModal.communicationPreferences.title'
                )}
                subtitle={getTranslation(
                    'settingsModal.communicationPreferences.subtitle'
                )}
            />
        </>
    );
};
